import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";
import AuthenticationService from "../../../../../service/auth/AuthenticationService";

export class NavigoDashboardUtils {
  constructor() {
    this.apiService = new APIService();
    this.helper = new Helper();
    this.authenticationService = new AuthenticationService();
  }

  getAccountsByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.accountDashboard.getAccountsByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  fetchKeyAccountManagers(onResponse, onError) {
    let url = APIConfig.bridgeEmployee.getAll;
    return this.apiService.get(url, onResponse, onError);
  }
  fetchPatientId(id, onResponse, onError) {
    let url = APIConfig.patient.get.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getEmployeeById(id, onResponse, onError) {
    let url = APIConfig.user.get.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getDoctorById(id, onResponse, onError) {
    let url = APIConfig.followUp.doctorNameById.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getAccountsForPid(id, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getAccountsForPid.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getPlansForPid(pid, accId, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getPlansForPid.format(pid);
    return this.apiService.get(url, onResponse, onError);
  }
  processMoney(body, wid, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.processMoney.format(wid);
    return this.apiService.post(url, body, onResponse, onError);
  }
  getAssignedServicesToPlanByFilter = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.getAssignedServicesToPlanByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  };
  getProviderOfPlanService = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.plan.getProviderOfPlanService;
    return this.apiService.post(url, body, onResponse, onError);
  };
  getFamilyMembers = (pid, onResponse, onError) => {
    let url = APIConfig.familyPlan.getFamilyMembers.format(pid);
    return this.apiService.get(url, onResponse, onError);
  };
  getAllRelation = (onResponse, onError) => {
    let url = APIConfig.familyPlan.getAllRelation;
    return this.apiService.get(url, onResponse, onError);
  };
  getAvailableSlots(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getAvailableSlots;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getAvailableSlotsRange(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getAvailableSlotsRange;
    return this.apiService.post(url, body, onResponse, onError);
  }
  // POST /v1/appointment/available-slots/range — a window of days starting at
  // slotRangeStartDate. Same endpoint the cart module books from, hence its key.
  getAvailableSlotsByRange(body, onResponse, onError) {
    let url = APIConfig.cartDashboard.availableSlotsByRange;
    return this.apiService.post(url, body, onResponse, onError);
  }
  fetchReasonsForConsultation = (onResponse, onError) => {
    let url = APIConfig.myPlan.navigo.reasonsForConsultation;
    return this.apiService.get(url, onResponse, onError);
  };
  createAppointment = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.navigo.createAppointment;
    return this.apiService.postAgain(url, body, onResponse, onError);
  };
  getSPLocation = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.navigo.location;
    return this.apiService.post(url, body, onResponse, onError);
  };
  getPatientAddress = (pid, onResponse, onError) => {
    let url = APIConfig.familyPlan.primaryAddress.format(pid);
    return this.apiService.get(url, onResponse, onError);
  };
  getAddressById = (aid, onResponse, onError) => {
    let url = APIConfig.familyPlan.addressById.format(aid);
    return this.apiService.get(url, onResponse, onError);
  };
  getSPLocation = (body, onResponse, onError) => {
    let url = APIConfig.myPlan.navigo.location;
    return this.apiService.post(url, body, onResponse, onError);
  };
  fetchAppointments = (
    body,
    onResponse,
    onError,
    includeServiceDetails = false,
  ) => {
    let url = APIConfig.myPlan.navigo.fetchAppointments;
    if (includeServiceDetails) {
      url = url + "&includeServiceDetails=true";
    }
    // Opt-in: when the caller sets includeEvents, request the appointment's
    // payment/refund eventHistory via query param (the base URL already carries
    // includeDetails=true, so this is appended with &).
    if (body?.includeEvents) {
      url += "&includeEvents=true";
    }
    return this.apiService.post(url, body, onResponse, onError);
  };
  getServiceProvidersByFilter(body, onResponse, onError) {
    let url =
      APIConfig.myPlan.serviceProviderDashboard.fetchServiceProvidersByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getServicesByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.serviceDashboard.fetchServicesByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  filterByPhone(cc, phone, onResponse, onError) {
    let tenantid = this.authenticationService.getTenantId();
    let url = APIConfig.patient.getProfileIds.format(phone, cc, tenantid);
    return this.apiService.get(url, onResponse, onError);
  }
  getAppointmentDocMapping(id, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getAppointmentDocMapping.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getAppointmentAudit(appId, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getAppointmentAudit.format(appId);
    return this.apiService.get(url, onResponse, onError);
  }
  // Asks document-service for a short-lived signed GCS URL scoped to this one
  // recording. The URL expires (~15 min), so fetch it on demand rather than
  // caching it across a session.
  getCallRecordingSignedUrl(recordingId, onResponse, onError) {
    let url =
      APIConfig.myPlan.navigo.getCallRecordingSignedUrl.format(recordingId);
    return this.apiService.get(url, onResponse, onError);
  }
  uploadDocument(fileUrl, fileName, document, onSuccess, onError, pId = null) {
    let documentRequest = new FormData();
    let documentJSON = {};
    // documentJSON.id = document.id;
    documentJSON.patientId = pId;

    documentJSON.title = fileName;
    documentJSON.description = document.description;
    documentJSON.type = document.type;
    documentJSON.format = document.format;
    documentJSON.status = document.status;

    documentRequest.append("file", fileUrl);
    documentRequest.append("fileName", fileName);
    documentRequest.append("document", JSON.stringify(documentJSON));
    documentRequest.append("patientId", pId);

    const url = APIConfig.documentApis.uploadDoc;
    this.apiService.postWithFormData(
      url,
      documentRequest,

      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
  uploadDocumentDigital(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.mapDocToApp;
    return this.apiService.post(url, body, onResponse, onError);
  }
  uploadDocumentLabtestAutomation(body, onResponse, onError) {
    let url = APIConfig.navigoDashboard.uploadDocumentLabtestAutomation;
    return this.apiService.post(url, body, onResponse, onError);
  }
  handleStatusUpdate(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.statusUpdate;
    return this.apiService.post(url, body, onResponse, onError);
  }
  handleOnlyRefund(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.refund;
    return this.apiService.post(url, body, onResponse, onError);
  }
  // Dry run of the same endpoint: `preview: true` plans the refund and reports what WOULD move
  // per source, without minting a group id, creating refunds, touching the timeline or emailing
  // the customer. Always answers 200 — including "nothing left to refund", which is a valid
  // answer to the question rather than the 409 the real call returns.
  previewRefund(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.refund;
    return this.apiService.post(
      url,
      { ...body, preview: true },
      onResponse,
      onError,
    );
  }
  // check=true is a dry run: the backend runs every eligibility guard and returns
  // without touching the appointment, so a body of just { appointmentID } is valid.
  rescheduleAppointment(body, onResponse, onError, check = false) {
    let url = APIConfig.myPlan.navigo.rescheduleAppointment;
    if (check) {
      url = url + "?check=true";
    }
    return this.apiService.post(url, body, onResponse, onError);
  }
  getRescheduleReasons(onResponse, onError) {
    let url = APIConfig.myPlan.navigo.rescheduleReasons;
    return this.apiService.get(url, onResponse, onError);
  }
  getCancellationReasons(onResponse, onError) {
    let url = APIConfig.myPlan.navigo.cancellationReasons;
    return this.apiService.get(url, onResponse, onError);
  }
  updateExtOrderId(appId, eoid, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.updateExtOrderId.format(appId, eoid);
    return this.apiService.put(url, null, onResponse, onError);
  }
  getModes(onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getModes;
    return this.apiService.get(url, onResponse, onError);
  }
  getServices(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getServices;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getServiceProvider(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getServiceProvider;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getPrice(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getPrice;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getHomeSampleDates(pid, planId, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getHomeSampleDates.format(pid, planId);
    return this.apiService.get(url, onResponse, onError);
  }
  getAvailCareDates(pid, planId, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getAvailCareDates.format(pid, planId);
    return this.apiService.get(url, onResponse, onError);
  }
  getBookingConfigByVendor(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getBookingConfigByVendor;
    return this.apiService.post(url, body, onResponse, onError);
  }
  checkAddressServiceable(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.checkAddressServiceable;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getLanguages(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getLanguages;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getServiceProviderById(id, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.getById.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getPriorityVendors(onResponse, onError) {
    let url = APIConfig.myPlan.navigo.getPriorityVendors;
    return this.apiService.get(url, onResponse, onError);
  }
  updateProfileInfo(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.updateProfileInfo;
    return this.apiService.put(url, body, onResponse, onError);
  }
  getPlacesAutocomplete(body, onResponse, onError) {
    const url = APIConfig.gmap.placesAutocomplete;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getCoordinatesByPlaceId(body, onResponse, onError) {
    const url = APIConfig.gmap.placeIdToCoordinates;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getAddressByCoordinates(body, onResponse, onError) {
    const url = APIConfig.gmap.latLngToAddress;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getCoordinatesFromAddressId(addressId, onResponse, onError) {
    const url = APIConfig.gmap.getCoordinatesFromAddressId.format(addressId);
    return this.apiService.get(url, onResponse, onError);
  }
  generatePaymentLink(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.generatePaymentLink;
    return this.apiService.post(url, body, onResponse, onError);
  }
  checkCurrentWalletDetails(body, onResponse, onError) {
    let url = APIConfig.myPlan.navigo.checkCurrentWalletDetails;
    return this.apiService.post(url, body, onResponse, onError);
  }
}

export default NavigoDashboardUtils;
